:host {
  white-space: nowrap;
}